import { http } from '../utils/http'

// dataTarget 查询
const searchAction = (params, page, size) => {
    const url = `/config/dataTargetConfigInfo/page`
    return http.post(url, params, page, size)
};

// dataTarget 新增/修改
const addAction = (params) => {
    const url = `/config/dataTargetConfigInfo/save`
    return http.post(url, params)
};

// dataTarget 获取详情
const getInfoAction = (id) => {
    const url = `/config/dataTargetConfigInfo/get/${id}`
    return http.post(url)
};

// dataTarget 锁定
const lockAction = (params) => {
    const url = `/config/dataTargetConfigInfo/changeStatus`
    return http.post(url, params)
};

// dataTarget 复制
const copyAction = (params) => {
    const url = `/config/dataTargetConfigInfo/copy`
    return http.post(url, params)
};

// 导入
const importAction = (params) => {
    const url = `/config/dataTargetConfigInfo/import`
    return http.post(url, params)
};

// 导出
const exportAction = (params) => {
    const url = `/config/dataTargetConfigInfo/export`
    return http.post(url, params)
};

// customer
const customerAction = () => {
    const url = `/config/customer/list`
    return http.post(url)
};

// groovy
const groovyAction = (client) => {
    const url = `/config/groovyScript/clientList/${client}`
    return http.post(url)
};

// text DB
const textDB = (params) => {
    const url = `/api/v1/file/jdbc/ping`
    return http.post(url, params)
};

// text SFTP
const textSFTP = (params) => {
    const url = `/api/v1/file/sftp/ping`
    return http.post(url, params)
};

// text Blob
const textBlob = (params) => {
    const url = `/api/v1/file/blob/ping`
    return http.post(url, params)
};

const getKeyVaultNameList = () => {
    const url = `/config/keyVault/getKeyVaultNameAndId`
    return http.post(url)
};

const getNameAndWordByKV = (id) => {
    const url = `/config/keyVault/getNameAndWordByKV/${id}`
    return http.post(url)
};

export default {
    searchAction,
    addAction,
    lockAction,
    copyAction,
    importAction,
    exportAction,
    getInfoAction,
    customerAction,
    groovyAction,
    textDB,
    textSFTP,
    textBlob,
    getKeyVaultNameList,
    getNameAndWordByKV
  }